import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getWeddings,
  getFilms,
  getPrewedding,
  getPreweddingSessions,
  getTestimonials,
  getInstagram,
  getInquiries,
} from "@/lib/cloudApi";
import { listSecureClientGalleries } from "@/lib/clientGallerySecureApi";
import { Heart, Film, Image, MessageSquare, Instagram, Inbox, Images, Plus } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ weddings: 0, films: 0, prewedding: 0, preweddingSessions: 0, testimonials: 0, instagram: 0, inquiries: 0, clientGalleries: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [w, f, p, pws, t, i, inq, cg] = await Promise.all([
          getWeddings(),
          getFilms(),
          getPrewedding(),
          getPreweddingSessions(),
          getTestimonials(),
          getInstagram(),
          getInquiries(),
          listSecureClientGalleries().catch(() => []),
        ]);
        setStats({
          weddings: w?.length || 0,
          films: f?.length || 0,
          prewedding: p?.length || 0,
          preweddingSessions: pws?.length || 0,
          testimonials: t?.length || 0,
          instagram: i?.length || 0,
          inquiries: inq?.length || 0,
          clientGalleries: cg?.length || 0,
        });
      } catch (e) { /* noop */ }
    })();
  }, []);

  const cards = [
    { to: "/admin/weddings", label: "Weddings", icon: Heart, count: stats.weddings },
    { to: "/admin/pre-wedding", label: "Pre-Wedding Sessions", icon: Image, count: stats.preweddingSessions },
    { to: "/admin/films", label: "Films", icon: Film, count: stats.films },
    { to: "/admin/client-galleries", label: "Client Galleries", icon: Images, count: stats.clientGalleries },
    { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquare, count: stats.testimonials },
    { to: "/admin/instagram", label: "Instagram Tiles", icon: Instagram, count: stats.instagram },
    { to: "/admin/inquiries", label: "Inquiries", icon: Inbox, count: stats.inquiries },
  ];

  return (
    <div className="p-6 md:p-10" data-testid="admin-dashboard">
      <div className="admin-card p-6 md:p-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div>
            <div className="eyebrow text-[#C99A45]">Admin Overview</div>
            <h1 className="font-serif-display text-5xl mt-3">Dashboard</h1>
            <p className="text-sm text-[#6f6a62] mt-3 max-w-2xl">
              A clean control room for stories, films, private galleries, and website content.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            <Link to="/admin/weddings/new" className="btn-gold-outline !py-3"><Plus size={13} /> Wedding</Link>
            <Link to="/admin/pre-wedding" className="btn-gold-outline !py-3"><Plus size={13} /> Pre-Wedding</Link>
            <Link to="/admin/films" className="btn-gold-outline !py-3"><Plus size={13} /> Film</Link>
            <Link to="/admin/client-galleries" className="btn-gold-outline !py-3"><Plus size={13} /> Gallery</Link>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-6">
        {cards.map(({ to, label, icon: Icon, count }) => (
          <Link key={to} to={to} className="admin-card p-6 hover:-translate-y-0.5 transition" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center justify-between gap-3">
              <span className="eyebrow text-[10px] text-[#6f6a62]">{label}</span>
              <span className="h-10 w-10 rounded-full bg-[#b8914a]/10 text-[#b8914a] flex items-center justify-center">
                <Icon size={18} />
              </span>
            </div>
            <div className="font-serif-display text-5xl text-[#171717] mt-5">{count}</div>
          </Link>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-4 mt-6">
        <div className="admin-card p-6">
          <div className="eyebrow">Recent Updates</div>
          <p className="text-sm text-[#6f6a62] mt-3">Recent content activity will appear here as your data grows.</p>
        </div>
        <div className="admin-card p-6">
          <div className="eyebrow">CMS Health</div>
          <p className="text-sm text-[#6f6a62] mt-3">Public website content, Supabase admin auth, and private client galleries remain separated.</p>
        </div>
      </div>
    </div>
  );
}
